import React from 'react';

export function PanelHeader({ title, children }) {
  return (
    <div className="ci-panel-header">
      <h3>{title}</h3>
      <div className="ci-panel-actions">{children}</div>
    </div>
  );
}
